module.exports = __webpack_public_path__ + "img/ic24NameRed.41925b1e.svg";